import { BrowserRouter, Routes, Route, Navigate, useParams } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { PreferencesProvider } from './contexts/PreferencesContext';
import { ConfirmProvider } from './contexts/ConfirmContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { AppLayout } from './components/AppLayout';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { MeetingsPage } from './pages/MeetingsPage';
import { MeetingSeriesPage } from './pages/MeetingSeriesPage';
import { MeetingInstancePage } from './pages/MeetingInstancePage';
import { TasksPage } from './pages/TasksPage';
import { TaskDetailPage } from './pages/TaskDetailPage';
import { TagsPage } from './pages/TagsPage';
import { PeoplePage } from './pages/PeoplePage';
import { PersonDetailPage } from './pages/PersonDetailPage';
import { InboxPage } from './pages/InboxPage';
import { ViewsPage } from './pages/ViewsPage';
import { ViewDetailPage } from './pages/ViewDetailPage';
import { ProjectsPage } from './pages/ProjectsPage';
import { ProjectDetailPage } from './pages/ProjectDetailPage';
import { SearchPage } from './pages/SearchPage';
import { TimelinePage } from './pages/TimelinePage';
import { NotesPage } from './pages/NotesPage';
import { NoteDetailPage } from './pages/NoteDetailPage';
import { SettingsPage } from './pages/SettingsPage';
import { DayViewPage } from './pages/DayViewPage';
import { ArchivePage } from './pages/ArchivePage';
import { RemindersPage } from './pages/RemindersPage';

function RedirectRefDoc() {
  const { docId } = useParams();
  return <Navigate to={`/views/${docId}`} replace />;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <PreferencesProvider>
        <ConfirmProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route element={<ProtectedRoute />}>
            <Route element={<AppLayout />}>
              <Route path="/" element={<DashboardPage />} />
              <Route path="/inbox" element={<InboxPage />} />
              <Route path="/meetings" element={<MeetingsPage />} />
              <Route path="/meetings/standalone/:instanceId" element={<MeetingInstancePage />} />
              <Route path="/meetings/:seriesId" element={<MeetingSeriesPage />} />
              <Route path="/meetings/:seriesId/:instanceId" element={<MeetingInstancePage />} />
              <Route path="/tasks" element={<TasksPage />} />
              <Route path="/tasks/:taskId" element={<TaskDetailPage />} />
              <Route path="/projects" element={<ProjectsPage />} />
              <Route path="/projects/:projectId" element={<ProjectDetailPage />} />
              <Route path="/tags" element={<TagsPage />} />
              <Route path="/people" element={<PeoplePage />} />
              <Route path="/people/:personId" element={<PersonDetailPage />} />
              <Route path="/views" element={<ViewsPage />} />
              <Route path="/views/:docId" element={<ViewDetailPage />} />
              <Route path="/notes" element={<NotesPage />} />
              <Route path="/notes/:noteId" element={<NoteDetailPage />} />
              <Route path="/references" element={<Navigate to="/views" replace />} />
              <Route path="/references/:docId" element={<RedirectRefDoc />} />
              <Route path="/search" element={<SearchPage />} />
              <Route path="/timeline" element={<TimelinePage />} />
              <Route path="/day/:date" element={<DayViewPage />} />
              <Route path="/reminders" element={<RemindersPage />} />
              <Route path="/archive" element={<ArchivePage />} />
              <Route path="/settings" element={<SettingsPage />} />
            </Route>
          </Route>
        </Routes>
        </ConfirmProvider>
        </PreferencesProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
